import { Color, DefaultValue } from '@billy/design-system'
import styled from '@emotion/styled'

import { NavigationVariant } from '../../types/navigationVariant'

const backgroundByVariant: Record<NavigationVariant, Color> = {
  default: Color.Green800,
  inverted: Color.Yellow100,
}

interface UmbrellaAvatarWrapperProps {
  variant: NavigationVariant
}

export const UmbrellaAvatarWrapper = styled.div<UmbrellaAvatarWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  min-width: 32px;
  height: 32px;
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${({ variant }) => backgroundByVariant[variant]};
`
